import React, { useState, useEffect } from "react";
import SeatMap from "./Seatmap";
import { BaggageOffcanvas, MealOffcanvas } from "./FlightAddon";

/**
 * AddonManager
 * Props:
 *   contractId           string
 *   returnContractId     string | null
 *   isInternational      boolean
 *   isB2C                boolean
 *   grossPrice           number
 *   discount             number
 *   openPanel            "seat" | "meal" | "baggage" | null
 *   onPanelChange        fn
 *   showInternalButtons  boolean
 *   useDummy             boolean  (skip API, use random seats)
 */
export default function AddonManager({
  contractId,
  returnContractId = null,
  isInternational = false,
  isB2C = false,
  grossPrice = 0,
  discount = 0,
  openPanel: externalOpenPanel = null,
  onPanelChange,
  showInternalButtons = false,
  useDummy = false,
}) {
  const [openPanel, setOpenPanel] = useState(null);

  useEffect(() => {
    if (externalOpenPanel !== openPanel) {
      setOpenPanel(externalOpenPanel);
    }
  }, [externalOpenPanel]);

  const handlePanelChange = (panel) => {
    setOpenPanel(panel);
    if (onPanelChange) onPanelChange(panel);
  };

  const [seatPrice, setSeatPrice] = useState(
    () => parseFloat(localStorage.getItem("totalSeatPrice") || "0")
  );
  const [baggagePrice, setBaggagePrice] = useState(
    () => parseFloat(localStorage.getItem("totalBaggagePrice") || "0")
  );
  const [mealPrice, setMealPrice] = useState(
    () => parseFloat(localStorage.getItem("totalMealPrice") || "0")
  );

  const combinedTotal = seatPrice + baggagePrice + mealPrice;
  const youPay = grossPrice - discount + combinedTotal;

  useEffect(() => {
    const setEl = (id, text) => { const el = document.getElementById(id); if (el) el.textContent = text; };
    const setVal = (id, val) => { const el = document.getElementById(id); if (el) el.value = val; };
    setEl("combinedTotalPrice", `Rs. ${combinedTotal}`);
    setVal("GrossPrice", youPay.toFixed(1));
    const payEl = document.querySelector(".pay_total span:last-child");
    if (payEl) payEl.textContent = `Rs.${youPay.toFixed(1)}`;
    if (window.$) {
      const upd = (label, price) =>
        window.$(`.price_detail:contains("${label}") .price`).text(
          price > 0 ? `Rs. ${price.toFixed(1)}` : "Rs. 0.00"
        );
      upd("Seat", seatPrice);
      upd("Meal", mealPrice);
      upd("Baggage", baggagePrice);
    }
  }, [seatPrice, baggagePrice, mealPrice, combinedTotal, youPay]);

  // SeatMap onDone => (seats[], totalPrice)
  const handleSeatDone = (_seats, totalPrice) => {
    const p = parseFloat(totalPrice) || 0;
    setSeatPrice(p);
    localStorage.setItem("totalSeatPrice", p);
    handlePanelChange(null);
  };

  // BaggageOffcanvas onDone => (totalPrice)
  const handleBaggageDone = (totalPrice) => {
    const p = parseFloat(totalPrice) || 0;
    setBaggagePrice(p);
    localStorage.setItem("totalBaggagePrice", p);
    handlePanelChange(null);
  };

  // MealOffcanvas onDone => (totalPrice)
  const handleMealDone = (totalPrice) => {
    const p = parseFloat(totalPrice) || 0;
    setMealPrice(p);
    localStorage.setItem("totalMealPrice", p);
    handlePanelChange(null);
  };

  return (
    <>
      {showInternalButtons && (
        <div className="view_box">
          <div className="flight_preview">
            <div className="flight_preview_head justify-content-start">
              <div className="addon_link" onClick={() => handlePanelChange("seat")} style={{ cursor: "pointer" }}>
                <span className="addon_icon icon_seat"></span>Seat Selection
              </div>
              <div className="addon_link" onClick={() => handlePanelChange("meal")} style={{ cursor: "pointer" }}>
                <span className="addon_icon icon_meal"></span>Add Meals
              </div>
              <div className="addon_link" onClick={() => handlePanelChange("baggage")} style={{ cursor: "pointer" }}>
                <span className="addon_icon icon_baggage"></span>Add Baggage
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Backdrop */}
      {openPanel && (
        <div
          onClick={() => handlePanelChange(null)}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1050 }}
        />
      )}

      {/* Seat */}
      {openPanel === "seat" && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1060, pointerEvents: "none" }}>
          <div style={{ pointerEvents: "auto", position: "absolute", right: 0, top: 0, height: "100%", width: "1100px", maxWidth: "98vw" }}>
            <SeatMap
              contractId={contractId}
              returnContractId={returnContractId}
              isB2C={isB2C}
              useDummy={useDummy}
              onDone={handleSeatDone}
            />
          </div>
        </div>
      )}

      {/* Baggage */}
      {openPanel === "baggage" && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1060, pointerEvents: "none" }}>
          <div style={{ pointerEvents: "auto", position: "absolute", right: 0, top: 0, height: "100%", width: "520px", maxWidth: "96vw" }}>
            <BaggageOffcanvas
              contractId={contractId}
              returnContractId={returnContractId}
              isInternational={isInternational}
              onDone={handleBaggageDone}
            />
          </div>
        </div>
      )}

      {/* Meal */}
      {openPanel === "meal" && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1060, pointerEvents: "none" }}>
          <div style={{ pointerEvents: "auto", position: "absolute", right: 0, top: 0, height: "100%", width: "520px", maxWidth: "96vw" }}>
            <MealOffcanvas
              contractId={contractId}
              returnContractId={returnContractId}
              onDone={handleMealDone}
            />
          </div>
        </div>
      )}
    </>
  );
}